import { Badge, FluentProvider, Text } from "@fluentui/react-components";
import * as React from "react";
import StringsStore from "sh-strings/store";
import ThemeUtils from "../../../utility/ThemeUtils";
import { ECSConfigKey, ECSConfigService } from "sh-services";
import { TeamStore } from "sh-stores";
import MemberUtils from "../../../utility/MemberUtils";

export type SmartScheduleBadgeIntent = "info" | "success" | "error";

export interface SmartScheduleBadgeProps {
    message?: string;
    intent?: SmartScheduleBadgeIntent;
}

export const SmartScheduleBadge: React.FC<SmartScheduleBadgeProps> = ({ message, intent = "info" }) => {
    const _strings = StringsStore().registeredStringModules.get("smartSchedule").strings;
    const isCurrentUserAdmin: boolean = MemberUtils.isAdmin(TeamStore() && TeamStore().me);

    let color: any;
    switch (intent) {
        case "success":
            color = "success" as any;
            break;
        case "error":
            color = "danger" as any;
            break;
        case "info":
        default:
            color = "brand" as any;
            break;
    }
    const display = message || _strings.get("generatingScheduleLabel");

    return (
        isCurrentUserAdmin && ECSConfigService.isECSFeatureEnabled(ECSConfigKey.EnableSmartScheduling) && <FluentProvider theme={ThemeUtils.getFluentV2ShiftTheme()} style={{ backgroundColor: "var(--transparent-background)" }}>
            <Badge
                id="SmartScheduleBadgeLabel"
                appearance="tint"
                color={color}
                size="medium"
                shape="rounded"
                aria-label={display}
                style={{ marginLeft: "8px", maxWidth: "240px", overflow: "hidden", textOverflow: "ellipsis", borderRadius: "16px", height: "20px" }}
            >
                <Text size={100} weight="semibold" title={display}>
                    {display}
                </Text>
            </Badge>
        </FluentProvider>
    );
};

export default SmartScheduleBadge;
